// Api End Point
export const URL = 'soilsampling/job/'

// State Configuration
export const MODEL = 'SamplingJobs'
export const TREE = 'soilJobData'
export const BRANCH = 'soilJobs'

// Model Properties
export const PROP_ID = 'id'
export const PROP_SOIL_JOB_ID = PROP_ID
export const PROP_SAMPLING_JOB_ID = PROP_ID
export const PROP_CREATED_BY = 'created_by'
export const PROP_COMPLETED_BY = 'completed_by'
export const PROP_ASSIGNED_TO = 'assigned_to'
export const PROP_SUBFIELD = 'subfield'
export const PROP_PREVIOUS_POINTS = 'previous_points'
export const PROP_CREATED_DATE = 'created_date'
export const PROP_COMPLETE = 'complete'
export const PROP_COMPLETED_DATE = 'completed_date'
export const PROP_SAMPLING_TYPE = 'samplingType'
export const PROP_STATUS = 'status'
export const PROP_GRID_SIZE = 'grid_size'
export const PROP_ACTION = 'action'
export const PROP_FIELD = 'field'
export const PROP_FARM = 'farm'
export const PROP_GROWER = 'grower'
export const PROP_PAID = 'paid'
export const PROP_PRICE = 'price'
export const PROP_TYPE = 'type'

// Job types
export const TYPE_AGPHD_SOILS = 'AgPhD Soils'

// Asset PROPs
export const PROP_ASSET_ID = PROP_ID
export const PROP_ASSET_LABEL = 'label'
export const PROP_ASSET_PARENT = 'parent'

// Client PROPs
export const PROP_CLIENT_FIRST = 'first'
export const PROP_CLIENT_LAST = 'last'

// Status options
export const SET_GRID = 'Set Grid'
export const READY_TO_SAMPLE = 'Ready to Sample'
export const ORDER_TEST = 'Order Test'
export const SAMPLING = 'Sampling'
export const SHIPPING = 'Shipping'
export const RESULTS_POSTED = 'Results Posted'
export const JOB_STATUS_OPTIONS = [SET_GRID, READY_TO_SAMPLE, SAMPLING, ORDER_TEST, SHIPPING, RESULTS_POSTED]

// Grid Types
export const ZONE_TYPE = 'Zone'
export const GRID_TYPE = 'Grid'
export const COMPOSITE_TYPE = 'Composite'

// Date
export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss' // 2017-01-26T14:09:54.833022
